"use client";

import { motion } from "framer-motion";
import {
  Layers,
  Clock,
  Users,
  Star,
  ShoppingBag,
  Sparkles,
} from "lucide-react";
import { GlassCard } from "./glass-card";

const PILLARS = [
  {
    id: "tagging",
    title: "Tagging IA",
    description: "Classification automatique des tickets : tags, priorité et sentiment dès la création.",
    icon: Sparkles,
    span: "col-span-2 row-span-1",
  },
  {
    id: "omnicanal",
    title: "Omnicanalité",
    description: "Email, WhatsApp, Chat widget, Meta — une seule inbox unifiée.",
    icon: Layers,
    span: "col-span-1 row-span-2",
  },
  {
    id: "sla",
    title: "SLA & Alertes",
    description: "Délais de première réponse et de résolution, alertes en cas de dépassement.",
    icon: Clock,
    span: "col-span-1 row-span-1",
  },
  {
    id: "fusion",
    title: "Fusion de profils",
    description: "Regroupez les conversations d'un même client sur tous les canaux.",
    icon: Users,
    span: "col-span-1 row-span-1",
  },
  {
    id: "csat",
    title: "CSAT & Trustpilot",
    description: "Sondage satisfaction après clôture et redirection des clients satisfaits vers Trustpilot.",
    icon: Star,
    span: "col-span-2 row-span-1",
  },
  {
    id: "shopify",
    title: "Shopify Actions",
    description: "Commandes, retours et contexte boutique directement dans l'inbox.",
    icon: ShoppingBag,
    span: "col-span-1 row-span-1",
  },
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.08 },
  },
};

const item = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0 },
};

export function BentoGrid() {
  return (
    <section className="relative px-4 py-20 md:py-28">
      <motion.div
        className="mx-auto max-w-6xl"
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-80px" }}
        variants={container}
      >
        <motion.h2
          className="text-center text-3xl font-bold tracking-tight text-white sm:text-4xl"
          variants={item}
        >
          Une plateforme pensée pour l&apos;e-commerce
        </motion.h2>
        <motion.p
          className="mx-auto mt-4 max-w-2xl text-center text-slate-400"
          variants={item}
        >
          Six piliers pour un support client à la pointe de la technologie.
        </motion.p>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:grid-rows-2">
          {PILLARS.map((pillar) => {
            const Icon = pillar.icon;
            return (
              <motion.div
                key={pillar.id}
                className={pillar.span}
                variants={item}
              >
                <GlassCard className="h-full transition hover:border-white/20 hover:bg-white/[0.07]">
                  <div className="flex h-full flex-col">
                    <div className="flex items-center gap-3">
                      <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-cyan-500/20 text-cyan-400">
                        <Icon className="h-5 w-5" />
                      </span>
                      <h3 className="font-semibold text-white">{pillar.title}</h3>
                    </div>
                    <p className="mt-3 flex-1 text-sm text-slate-400">
                      {pillar.description}
                    </p>
                  </div>
                </GlassCard>
              </motion.div>
            );
          })}
        </div>
      </motion.div>
    </section>
  );
}
